export default {
  slug: 'ws-online-store',
};
